import { OrderMediaCreateCategoryEnum } from './api/requests'
import { ProductCode } from './types'

export const MAX_PAGE_SIZE = 100

export const EFFECTIVE_DATE_VALID_AFTER = 0
export const EFFECTIVE_DATE_VALID_BEFORE = 30

export const SKIP_CHECK_IDENTIFICATION_NUMBERS = ['79592']

export const PRODUCTS_WITH_INSTALLMENTS = [
  ProductCode.CASCO,
  ProductCode.PROPERTY
]
export const PRODUCTS_WITH_ADJUSTMENT_PRICE = [
  ProductCode.CASCO,
  ProductCode.PROPERTY,
  ProductCode.CMR
]

export const ENABLE_GENERATE_OFFER = false

/**
 * `receipt` is intentionally not offered: it is for payment receipts, not for
 * order documents. See OrderMediaCreate.category for the guarantees semantics.
 */
export const ORDER_DOCUMENT_CATEGORIES = [
  OrderMediaCreateCategoryEnum.ORDER,
  OrderMediaCreateCategoryEnum.CONTRACT,
  OrderMediaCreateCategoryEnum.COMMON
]

export const DOCUMENT_CATEGORY_LABEL_KEY: Record<string, string> = {
  [OrderMediaCreateCategoryEnum.ORDER]: 'document_category_order',
  [OrderMediaCreateCategoryEnum.CONTRACT]: 'document_category_contract',
  [OrderMediaCreateCategoryEnum.COMMON]: 'document_category_common'
}
